import {
  StrategyType,
  StrategyTypeLabels,
  AllocationDpdFilter,
  AllocationDpdFilterLabels
} from './types';

export const DPD_OPTIONS = [
  {
    id: 'dpd-overall',
    value: AllocationDpdFilter.OVERALL,
    label: AllocationDpdFilterLabels[AllocationDpdFilter.OVERALL]
  },
  {
    id: 'dpd-1-30',
    value: AllocationDpdFilter.DPD_1_30,
    label: AllocationDpdFilterLabels[AllocationDpdFilter.DPD_1_30]
  },
  {
    id: 'dpd-30-plus',
    value: AllocationDpdFilter.DPD_30_PLUS,
    label: AllocationDpdFilterLabels[AllocationDpdFilter.DPD_30_PLUS]
  }
];

export const STRATEGY_OPTIONS = [
  {
    id: 'strategy-non-contactable',
    value: StrategyType.NON_CONTACTABLE,
    label: StrategyTypeLabels[StrategyType.NON_CONTACTABLE]
  },
  {
    id: 'strategy-no-ptp',
    value: StrategyType.CONTACTABLE_NO_PTP,
    label: StrategyTypeLabels[StrategyType.CONTACTABLE_NO_PTP]
  },
  {
    id: 'strategy-ptp',
    value: StrategyType.CONTACTABLE_PTP,
    label: StrategyTypeLabels[StrategyType.CONTACTABLE_PTP]
  }
];

const STRATEGY_SHORT_LABELS: Record<StrategyType, string> = {
  [StrategyType.NON_CONTACTABLE]: 'Non Contactable',
  [StrategyType.CONTACTABLE_NO_PTP]: 'No PTP',
  [StrategyType.CONTACTABLE_PTP]: 'PTP',
  [StrategyType.PAID]: 'Paid'
};

export const getCohortLabel = (
  allocationDpdFilter: AllocationDpdFilter,
  strategyType?: StrategyType
): string => {
  const dpdLabel =
    AllocationDpdFilterLabels[allocationDpdFilter] ||
    AllocationDpdFilterLabels[AllocationDpdFilter.OVERALL];
  const strategyLabel = strategyType ? StrategyTypeLabels[strategyType] : 'All';
  return `${dpdLabel} + ${strategyLabel} cases`;
};

export const PTP_SPLIT_ITEMS = [
  { key: 'broken', label: 'Broken' },
  { key: 'dueToday', label: 'Due today' },
  { key: 'future', label: 'Future' },
  { key: 'partiallyPaid', label: 'Partially paid' },
  { key: 'paid', label: 'Paid' }
] as const;

export const getFilterDisplayLabel = (
  allocationDpdFilter: AllocationDpdFilter,
  strategyType: StrategyType
): string => {
  const dpdLabel =
    AllocationDpdFilterLabels[allocationDpdFilter] ||
    AllocationDpdFilterLabels[AllocationDpdFilter.OVERALL];
  const strategyLabel = STRATEGY_SHORT_LABELS[strategyType] || 'All';
  return `${dpdLabel} + ${strategyLabel}`;
};
